module.exports = __webpack_public_path__ + "static/z_tall_hana'sfamous-2065d1edd1c6605c844c7b8944aa8b3f.jpg";